export function startDataDashboardEffect({ imgPanelEl, item }) {
  if (!imgPanelEl || !item) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.dash-canvas[data-kind="impact-trend"]');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const baseImpact = typeof item.impact === 'number' ? item.impact : 0.5;
  const base = [0.2, 0.33, 0.52, 0.68, baseImpact].map((v) => Math.min(0.95, Math.max(0.05, v)));

  let rafId = 0;
  let startT = 0;

  const tick = (t) => {
    if (!canvas.isConnected) return;
    if (!startT) startT = t;
    const dt = (t - startT) / 1000;

    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) {
      rafId = window.requestAnimationFrame(tick);
      return;
    }

    ctx.clearRect(0, 0, w, h);

    // Background grid
    ctx.strokeStyle = 'rgba(255,255,0,0.18)';
    ctx.lineWidth = 1;
    for (let i = 0; i <= 4; i++) {
      const y = (h - 10) - (i * (h - 20)) / 4;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(w, y);
      ctx.stroke();
    }

    // Subtle animated wobble so the panel feels alive
    const wobble = 0.03 + baseImpact * 0.04;
    const points = base.map((v, idx) => {
      const phase = dt * (0.8 + idx * 0.25) + idx;
      const n = Math.sin(phase) * wobble;
      return Math.min(0.98, Math.max(0.02, v + n));
    });

    const stroke = '#ffff00';
    ctx.strokeStyle = stroke;
    ctx.lineWidth = 3;
    ctx.beginPath();
    points.forEach((v, idx) => {
      const x = 10 + (idx * (w - 20)) / (points.length - 1);
      const y = (h - 10) - v * (h - 20);
      if (idx === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    });
    ctx.stroke();

    ctx.fillStyle = stroke;
    points.forEach((v, idx) => {
      const x = 10 + (idx * (w - 20)) / (points.length - 1);
      const y = (h - 10) - v * (h - 20);
      ctx.beginPath();
      ctx.arc(x, y, 4, 0, Math.PI * 2);
      ctx.fill();
    });

    rafId = window.requestAnimationFrame(tick);
  };

  rafId = window.requestAnimationFrame(tick);

  return () => window.cancelAnimationFrame(rafId);
}
